const initialState = { locationsList: [] };


export default function locationReducer (state = initialState, action) {

    switch (action.type) {
    case "SET_LOCATIONS_LIST":
        return { ...state, locationsList: action.payload };

    case "CLEAR_ALL_INPUT":
        return initialState;

    case "SET_ACCOUNT": {
        const account = action.payload;
        const locations = (account && account.locations)
              ? account.locations
              : [];

        return { ...state, locationsList: locations };
    }

    case "SET_ENTRY": {
        const account = action.payload && action.payload.account;
        let locations = [];

        if (account && account.locations) {
            locations = account.locations;
        }

        return { ...state, locationsList: locations };
    }

    default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./app/reducers/timeInput/locations.js